import { useEffect, useRef, useState } from "react";
import CountdownTimer from "../Shared Components/countdownTimer";
import { SALE_START_DATE, SALE_END_DATE } from "../urls";
import { getCurrentDate } from "../utils";

export default function SalesTimer({
  urgencyStartTime,
  urgencyEndTime,
  currentDate,
  services = [],
  containerStyle = {},
  boxStyle = {},
  seperatorStyle = {},
  handler,
  showSalesTimer=true,
}) {
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const currentDateRef = useRef(null);
  const [isDataSet, setIsDataSet] = useState(false);

  useEffect(() => {
    async function startTimer() {
      currentDateRef.current =
        currentDate || (await getCurrentDate()) || new Date();

      let isDataSetVar = false;

      if (
        urgencyStartTime &&
        urgencyEndTime &&
        currentDateRef.current >= new Date(urgencyStartTime) &&
        currentDateRef.current <= new Date(urgencyEndTime)
      ) {
        startDateRef.current = urgencyStartTime;
        endDateRef.current = urgencyEndTime;
        isDataSetVar = true;
      } else if (showSalesTimer) {
        let saleStartDate = null;
        let saleEndDate = null;
        let addOnTime = null;

        if (SALE_START_DATE && SALE_END_DATE) {
          if (
            SALE_START_DATE <= currentDateRef.current &&
            SALE_END_DATE >= currentDateRef.current
          ) {
            saleStartDate = SALE_START_DATE;
            saleEndDate = SALE_END_DATE;
          }
        }

        if (services.length > 0) {
          const updatedServices = services.filter((service) => {
            const date = new Date(service.end_time);
            return date > currentDateRef.current;
          });

          if (updatedServices.length > 0) {
            addOnTime = new Date(
              updatedServices.reduce((a, b) =>
                a.end_time < b.end_time ? a : b
              ).end_time
            );
          }
        }

        if (saleEndDate && addOnTime) {
          if (saleEndDate <= addOnTime) {
            startDateRef.current = saleStartDate;
            endDateRef.current = saleEndDate;
            isDataSetVar = true;
          } else {
            startDateRef.current = currentDateRef.current;
            endDateRef.current = addOnTime;
            isDataSetVar = true;
          }
        } else if (saleEndDate) {
          startDateRef.current = saleStartDate;
          endDateRef.current = saleEndDate;
          isDataSetVar = true;
        } else if (addOnTime) {
          startDateRef.current = currentDateRef.current;
          endDateRef.current = addOnTime;
          isDataSetVar = true;
        }
      }

      setIsDataSet(isDataSetVar);
    }

    startTimer();
  }, []);

  return isDataSet ? (
    <CountdownTimer
      startDate={new Date(startDateRef.current)}
      endDate={new Date(endDateRef.current)}
      currentDate={new Date(currentDateRef.current)}
      containerStyle={containerStyle}
      boxStyle={boxStyle}
      seperatorStyle={seperatorStyle}
      handler={handler}
    />
  ) : null;
}
